<script lang="ts">
    import type { TagNodeObject } from '$lib/bbcode/parser/types';
    import * as z from 'zod';
    import { cx } from '$lib/utils/cx';
    import MediaImageOrPlaceholder from '$components/MediaImage/MediaImageOrPlaceholder.svelte';

    export let node: TagNodeObject;

    const zAttrs = z.object({
        src: z.string().nullish(),
        media: z
            .union([
                z.string().transform((arg) => {
                    return parseInt(arg);
                }),
                z.number(),
            ])
            .nullish(),
        legend: z.string().nullish(),
        copyright: z.string().nullish(),
        alt: z.string().nullish(),
        title: z.string().nullish(),
        width: z.union([z.string(), z.number()]).nullish(),
        clickable: z.union([z.string(), z.boolean(), z.number()]).nullish(),
        class: z.string().nullish(),
        float: z.enum(['left', 'right']).nullish(),
    });

    $: attrs = zAttrs.parse(node.attrs);

    function normalizeWidth(width: number | string | null | undefined) {
        if (typeof width === 'number') {
            return `${width}px`;
        } else if (width == null) {
            return '100%';
        } else if (width.endsWith('%') || width.endsWith('px')) {
            return width;
        } else {
            return `${width}px`;
        }
    }
</script>

<div
    class={cx('photo', attrs.class ?? '')}
    class:photo-pull-left={attrs.float === 'left'}
    class:photo-pull-right={attrs.float === 'right'}
    style={`--w: ${normalizeWidth(attrs.width)}`}
>
    {#if attrs.media != null}
        <MediaImageOrPlaceholder
            mediaId={attrs.media}
            format="w1000"
            alt={attrs.alt}
            title={attrs.title}
            class="w-[--w] h-auto"
        />
    {:else if attrs.src != null}
        <img src={attrs.src} alt={attrs.alt} title={attrs.title} class="w-[--w] h-auto" />
    {:else}
        <MediaImageOrPlaceholder
            mediaId={null}
            format="w1000"
            alt={attrs.alt}
            title={attrs.title}
            class="w-[--w] h-auto"
        />
    {/if}

    {#if attrs.legend != null && attrs.legend !== ''}
        <div class="legend">
            {attrs.legend}
            {#if attrs.copyright != null && attrs.copyright !== ''}
                <span class="copyright">&copy;&nbsp;{attrs.copyright}</span>
            {/if}
        </div>
    {:else if attrs.copyright != null && attrs.copyright !== ''}
        <div class="legend">
            <span class="copyright">&copy;&nbsp;{attrs.copyright}</span>
        </div>
    {/if}
</div>
